import {createSlice, createAsyncThunk} from "@reduxjs/toolkit"
import thunkPromiseHandler from "../../scripts/thunkPromiseHandler"
import axios from "axios"

export const thunks = {
  login: createAsyncThunk("users/login", async (form, thunkAPI) => (
    thunkPromiseHandler(axios.post("/api/users/login", form), thunkAPI)
  ))
}

export const {reducer, actions} = createSlice({
  name: "users",
  initialState: {
    isLoading: false,
    user: JSON.parse(window.localStorage.getItem("user"))
  },
  reducers: {
    logout(state) {
      state.user = null
      window.localStorage.clear()
      //window.localStorage.removeItem('user');
    }
  },
  extraReducers({addCase}) {
    addCase(thunks.login.fulfilled, (state, {payload: user}) => {
      state.isLoading = false
      state.user = user
      window.localStorage.setItem("user", JSON.stringify(user))
    })
    addCase(thunks.login.rejected, (state, {payload: errorMessage}) => {
      alert(errorMessage || "Username or password wrong")
      state.isLoading = false
    })
    addCase(thunks.login.pending, (state) => {
      state.isLoading = true
    })
  }
})
